import { format } from "date-fns";

import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";

const DATE_FORMAT = "dd/MM/yyyy HH:mm";
const TIME_FORMAT = "HH:mm";

const LOG_TYPE_LABELS: Record<string, string> = {
	delivered: "Entregue ao Cliente",
	end: "Reparação finalizada",
	newState: "Novo estado",
	registration: "Entrada para Reparação",
	newTechnician: "Novo tecnico atribuido",
	quotation: "Novo orçamento",
	quotationAccepted: "Orçamento aprovado",
	canceled: "Cancelamento",
	clientResponse: "Resposta do Cliente",
	materialAvailable: "Material Disponível",
	addMaterial: "Material Adicionado",
	contactRequest: "Pedido de Contacto ao Cliente",
	creationAsComplaint: "Entrada como reclamação",
};

type RepairLogContext = {
	user?: string | number | null;
};

type RepairLog = {
	id?: string | number | null;
	type?: string | null;
	message?: string | null;
	date?: string | Date | null;
	context?: RepairLogContext | null;
};

type UserEntry = {
	name?: string | null;
};

type RepairHistoryTableProps = {
	logs: RepairLog[];
	users: Record<string, UserEntry>;
};

const resolveLogType = (value?: string | null) => {
	if (!value) {
		return "";
	}

	const key = value.replace("repair.", "");
	return LOG_TYPE_LABELS[key] ?? value;
};

const formatDate = (
	value?: string | Date | null,
	formatString = DATE_FORMAT,
) => {
	if (!value) {
		return "-";
	}

	const date = typeof value === "string" ? new Date(value) : value;
	if (Number.isNaN(date.getTime())) {
		return "-";
	}

	return format(date, formatString);
};

const stripHtml = (value: string) => value.replace(/<[^>]*>/g, "");

export function RepairHistoryTable({ logs, users }: RepairHistoryTableProps) {
	return (
		<div className="tp-RepairView__tableHistory overflow-hidden rounded-lg border border-border/60 bg-card/70">
			<Table>
				<TableHeader>
					<TableRow className="bg-muted/50">
						<TableHead>Evento</TableHead>
						<TableHead className="w-[170px]">Data</TableHead>
						<TableHead className="w-[130px]">Hora</TableHead>
						<TableHead className="w-[200px]">Por</TableHead>
					</TableRow>
				</TableHeader>
				<TableBody>
					{logs.map((entry, index) => {
						const rowKey = entry.id ?? `${entry.type ?? "log"}-${index}`;
						const userKey = entry.context?.user;
						const user =
							userKey !== null && userKey !== undefined
								? users[String(userKey)]
								: null;

						return (
							<TableRow key={rowKey}>
								<TableCell>
									<b>{resolveLogType(entry.type)}</b>
									<br />
									{entry.message ? (
										<span className="italic">{stripHtml(entry.message)}</span>
									) : (
										"-"
									)}
								</TableCell>
								<TableCell>{formatDate(entry.date, DATE_FORMAT)}</TableCell>
								<TableCell>{formatDate(entry.date, TIME_FORMAT)}</TableCell>
								<TableCell>{user?.name ?? "-"}</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</div>
	);
}
